import * as React from 'react'
import type { SVGProps } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { CommonComponentProps } from '@pijma/hero-types'

export const IconLongSmallArrowRight = (
  props: SVGProps<SVGSVGElement> & CommonComponentProps,
) => (
  <PijmaComponent
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    as="svg"
    commonProps={props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5858 13L13.2929 16.2929C12.9024 16.6834 12.9024 17.3166 13.2929 17.7071C13.6834 18.0976 14.3166 18.0976 14.7071 17.7071L19.7071 12.7071C20.0976 12.3166 20.0976 11.6834 19.7071 11.2929L14.7071 6.29289C14.3166 5.90237 13.6834 5.90237 13.2929 6.29289C12.9024 6.68342 12.9024 7.31658 13.2929 7.70711L16.5858 11H5.2C4.53726 11 4 11.4477 4 12C4 12.5523 4.53726 13 5.2 13H16.5858Z"
      fill="currentColor"
    />
  </PijmaComponent>
)
